import React from 'react';
import { PerformanceStat } from '../profileTypes';
import styles from './MonthPerformanceCard.module.css';

interface MonthPerformanceCardProps {
  stats: PerformanceStat[];
}

export const MonthPerformanceCard: React.FC<MonthPerformanceCardProps> = ({ stats }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>This Month's Performance</h3>
      <div className={styles.row}>
        {stats.map((stat) => (
          <div key={stat.id} className={styles.stat}>
            <p className={styles.value}>{stat.value}</p>
            <p className={styles.label}>{stat.label}</p>
          </div>
        ))}
      </div>
      <button className={styles.cta}>View Full Performance</button>
    </div>
  );
};
